//////////////////////This is import for API Call/////////////
import businessTypeService from "../services/businessTypeService";

export const GET_BUSINESS_TYPE = "GET_BUSINESS_TYPE";
export const GET_BUSINESS_TYPE_SUCCESS = "GET_BUSINESS_TYPE_SUCCESS";
export const GET_BUSINESS_TYPE_ERROR = "GET_BUSINESS_TYPE_ERROR";

export const GET_BUSINESS_TYPE_BY_ID = "GET_BUSINESS_TYPE_BY_ID";
export const GET_BUSINESS_TYPE_BY_ID_SUCCESS =
  "GET_BUSINESS_TYPE_BY_ID_SUCCESS";
export const GET_BUSINESS_TYPE_BY_ID_ERROR = "GET_BUSINESS_TYPE_BY_ID_ERROR";

export const CREATE_BUSINESS_TYPE = "CREATE_BUSINESS_TYPE";
export const CREATE_BUSINESS_TYPE_SUCCESS = "CREATE_BUSINESS_TYPE_SUCCESS";
export const CREATE_BUSINESS_TYPE_ERROR = "CREATE_BUSINESS_TYPE_ERROR";

export const UPDATE_BUSINESS_TYPE = "UPDATE_BUSINESS_TYPE";
export const UPDATE_BUSINESS_TYPE_SUCCESS = "UPDATE_BUSINESS_TYPE_SUCCESS";
export const UPDATE_BUSINESS_TYPE_ERROR = "UPDATE_BUSINESS_TYPE_ERROR";

export const DELETE_BUSINESS_TYPE = "DELETE_BUSINESS_TYPE";
export const DELETE_BUSINESS_TYPE_SUCCESS = "DELETE_BUSINESS_TYPE_SUCCESS";
export const DELETE_BUSINESS_TYPE_ERROR = "DELETE_BUSINESS_TYPE_ERROR";

export function getBusinessTypeRecord() {
  return async (dispatch) => {
    dispatch(getBusinessType());
    return await businessTypeService
      .getBusinessType()

      .then((response) => dispatch(getBusinessTypeSuccess(response.data)))
      .catch((error) => dispatch(getBusinessTypeError(error)));
  };
}

export function getBusinessType() {
  return {
    type: GET_BUSINESS_TYPE,
  };
}

export function getBusinessTypeSuccess(success) {
  return {
    type: GET_BUSINESS_TYPE_SUCCESS,
    payload: { success },
  };
}

export function getBusinessTypeError(error) {
  return {
    type: GET_BUSINESS_TYPE_ERROR,
    payload: { error },
  };
}

export function getBusinessTypeByIdRecord(id) {
  return async (dispatch) => {
    dispatch(getBusinessTypeById());
    return await businessTypeService
      .getBusinessTypeId(id)

      .then((response) => dispatch(getBusinessTypeByIdSuccess(response.data)))
      .catch((error) => dispatch(getBusinessTypeByIdError(error)));
  };
}

export function getBusinessTypeById() {
  return {
    type: GET_BUSINESS_TYPE_BY_ID,
  };
}

export function getBusinessTypeByIdSuccess(success) {
  return {
    type: GET_BUSINESS_TYPE_BY_ID_SUCCESS,
    payload: { success },
  };
}

export function getBusinessTypeByIdError(error) {
  return {
    type: GET_BUSINESS_TYPE_ERROR,
    payload: { error },
  };
}

export function createBusinessTypeRecord(businessTypes) {
  return async (dispatch) => {
    dispatch(createBusinessType());
    return await businessTypeService
      .createBusinessType(businessTypes)
      
      .then((response) => dispatch(createBusinessTypeSuccess(response)))
      .catch((error) => dispatch(createBusinessTypeError(error)));
  };
}

export function createBusinessType() {
  return {
    type: CREATE_BUSINESS_TYPE,
  };
}

export function createBusinessTypeSuccess(success) {
  return {
    type: CREATE_BUSINESS_TYPE_SUCCESS,
    payload: { success },
  };
}

export function createBusinessTypeError(error) {
  return {
    type: CREATE_BUSINESS_TYPE_ERROR,
    payload: { error },
  };
}

export function updateBusinessTypeRecord(businessTypes) {
  return async (dispatch) => {
    dispatch(updateBusinessType());
    return await businessTypeService
      .createBusinessType(businessTypes)

      .then((response) => dispatch(updateBusinessTypeSuccess(response)))
      .catch((error) => dispatch(updateBusinessTypeError(error)));
  };
}

export function updateBusinessType() {
  return {
    type: UPDATE_BUSINESS_TYPE,
  };
}

export function updateBusinessTypeSuccess(success) {
  return {
    type: UPDATE_BUSINESS_TYPE_SUCCESS,
    payload: { success },
  };
}

export function updateBusinessTypeError(error) {
  return {
    type: UPDATE_BUSINESS_TYPE_ERROR,
    payload: { error },
  };
}

export function deleteBusinessTypeRecord(id) {
  return async (dispatch) => {
    dispatch(deleteBusinessType());
    return await businessTypeService
      .deleteBusinessType(id)

      .then((response) => dispatch(deleteBusinessTypeSuccess(response)))
      .catch((error) => dispatch(deleteBusinessTypeError(error)));
  };
}

export function deleteBusinessType() {
  return {
    type: DELETE_BUSINESS_TYPE,
  };
}

export function deleteBusinessTypeSuccess(success) {
  return {
    type: DELETE_BUSINESS_TYPE_SUCCESS,
    payload: { success },
  };
}

export function deleteBusinessTypeError(error) {
  return {
    type: DELETE_BUSINESS_TYPE_ERROR,
    payload: { error },
  };
}
